// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"e60fbd8f","550":"5a3a1c85","725":"f6c11199"}[chunkId] + ".css";
};